import React, { useState, useEffect, useCallback } from 'react';
import CourseNotesList from './CourseNotesList';
import NoteEditor from './NoteEditor';
import { useData } from '../../contexts/DataContext';
import './CourseNotesContainer.css';

/**
 * CourseNotesContainer manages the list/detail view state for course notes.
 * Shows the note list by default, switches to editor when a note is selected.
 */
const CourseNotesContainer = ({ courseName, endeavorId }) => {
  const [selectedNote, setSelectedNote] = useState(null);
  const [showList, setShowList] = useState(true);
  const [listKey, setListKey] = useState(0);
  const { invalidateNotesCache } = useData();

  console.log('[CourseNotesContainer] Rendered with props:', { courseName, endeavorId, showList, selectedNote });

  // Reset to list view when course (endeavorId) changes
  useEffect(() => {
    console.log('[CourseNotesContainer] endeavorId changed, resetting to list view');
    setSelectedNote(null);
    setShowList(true);
  }, [endeavorId]);

  const handleNoteSelect = (note) => {
    console.log('[CourseNotesContainer] handleNoteSelect called with:', note);    console.log('[CourseNotesContainer] Note has content field:', !!note.content, 'length:', note.content?.length || 0);    setSelectedNote(note);
    setShowList(false);
    console.log('[CourseNotesContainer] State updated - selectedNote:', note.id, 'showList: false');
  };

  const handleBackToList = useCallback(() => {
    // Invalidate cache so list fetches fresh data on remount
    if (endeavorId) {
      invalidateNotesCache(endeavorId);
    }
    setSelectedNote(null);
    setShowList(true);
    setListKey(k => k + 1);
  }, [endeavorId, invalidateNotesCache]);

  const handleNoteSave = (savedContent) => {
    console.log('[CourseNotesContainer] Note saved, updating selectedNote content:', savedContent?.length || 0);
    // Update the selected note with the saved content
    if (selectedNote) {
      setSelectedNote({
        ...selectedNote,
        content: savedContent
      });
    }
  };

  if (!showList && selectedNote) {
    return (
      <div className="course-notes-container">
        <NoteEditor 
          noteId={selectedNote.id}
          endeavorId={endeavorId}
          initialContent={selectedNote.content || ''}
          onSave={handleNoteSave}
          onDelete={handleBackToList}
          onBack={handleBackToList}
        />
      </div>
    );
  }

  return (
    <div className="course-notes-container">
      <CourseNotesList 
        key={listKey}
        courseName={courseName}
        endeavorId={endeavorId}
        onSelectNote={handleNoteSelect}
      />
    </div>
  );
};

export default CourseNotesContainer;
